import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CodaltComponent} from '../codalt/codalt.component';
import {Ttm} from '../../classes/ttm';
import {TtmType} from '../../classes/ttmtype';
import {TtmStatus} from '../../classes/ttmstatus';
import {FormControl, FormGroup} from '@angular/forms';
import {TtmService} from '../../services/ttm.service';

@Component({
    selector: 'app-ttm-merge',
    templateUrl: './ttm-merge.component.html',
    styleUrl: './ttm-merge.component.scss'
})
export class TtmMergeComponent extends CodaltComponent implements OnInit {

    ttmTypes: TtmType[];
    ttmStatuses: TtmStatus[];
    nearbyTtms: Ttm[];
    ttm: Ttm;

    checked = new FormGroup({});

    constructor(public dialogRef: MatDialogRef<TtmMergeComponent>,
                @Inject(MAT_DIALOG_DATA) public data: {
                    ttm: Ttm,
                    nearbyTtms: Ttm[]
                },
                public ttmService: TtmService) {
        super();
    }

    ngOnInit() {
        this.subscriptions.add(this.ttmService.statuses().subscribe(statuses => {
            this.ttmStatuses = statuses.data;
        }));
        this.subscriptions.add(this.ttmService.types().subscribe(types => {
            this.ttmTypes = types.data;
        }));
        this.nearbyTtms = this.data.nearbyTtms.filter(t => t !== this.data.ttm).slice(0, 25);
        this.nearbyTtms.forEach(t => {
            this.checked.addControl(`${t.id}`, new FormControl(false));
        });
        this.ttm = this.data.ttm;
    }

    merge() {
        const toMergeWith = this.nearbyTtms.filter(nbt => this.checked.value[nbt.id]);
        this.subscriptions.add(this.ttmService.merge(this.ttm.id, toMergeWith.map(nbt => nbt.id)).subscribe(ttm => {
            this.ttm.amount = ttm.data.amount;
            this.ttm.entities.push(...toMergeWith.map(tmw => tmw.entities).flat());
            toMergeWith.forEach(tmw => tmw.entities.forEach(e => {
                e.ttm_id = this.ttm.id
            }));
            toMergeWith.forEach(tmw => {
                tmw.entities = [];
            });
            this.dialogRef.close({
                remove: toMergeWith
            });
        }));
    }
}
